<template>
  <div class="toolbar" :style="containerStyle">
    <!-- 左侧区域 -->
    <div class="toolbar-group left">
      <slot name="left"></slot>
      <template v-for="(item, index) in leftItems" :key="`left-${index}`">
        <ToolbarItem 
          :item="item" 
          @click="handleItemClick(item)"
          @menu-click="handleMenuClick(item, $event)"
        />
      </template>
    </div>

    <!-- 右侧区域 -->
    <div class="toolbar-group right">
      <template v-for="(item, index) in rightItems" :key="`right-${index}`">
        <ToolbarItem 
          :item="item" 
          @click="handleItemClick(item)"
          @menu-click="handleMenuClick(item, $event)"
          
        />
      </template>
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ToolbarItem from './ToolbarItem.vue';
// 配置示例
// const rightTools: ToolbarItemProps[] = [
//   {
//     icon: 'icon-undo',
//     icon: UndoOutlined,
//     label: '撤销',
//     tooltip: '撤销',
//     disabled: true
//   },
//   { type: 'separator' },
//   {
//     type: 'dropdown',
//     icon: 'icon-more',
//     tooltip: '更多操作',
//     menuItems: [
//       { label: '导出', key: 'export', onClick: () => console.log('导出') }
//     ]
//   }
// ];

// const leftTools = reactive<ToolbarItemProps[]>([
//   {
//     label: '新增',
//     tooltip: '创建新脚本',
//     onClick: () => console.log('新建')
//   },
//   { type: 'separator' },
//   {
//     type: 'custom',
//     render: renderCheckbox
//   },
//   { type: 'separator' },
//   {
//     type: 'dropdown',
//     label: '格式',
//     menuItems: [
//       {
//         label: '导出格式',
//         key: 'export',
//         children: [
//           { label: 'PDF', key: 'pdf', icon: FilePdfOutlined }
//         ]
//       }
//     ]
//   }
// ]);

// Toolbar.vue 中的类型定义
export interface ToolbarMenuItem {
  label: string;        // 菜单项文字
  key: string;          // 菜单项唯一标识
  icon?: any;  // 菜单项图标（Ant Design 组件）
  onClick?: () => void; // 点击事件（无子女时生效）
  children?: ToolbarMenuItem[]; // 二级/三级子菜单
  showSubMenu?: boolean; // 新增：控制子菜单显示/隐藏（响应式）
}

// 在 Toolbar.vue 中扩展类型定义
export interface ToolbarItemProps {
  type?: 'button' | 'separator' | 'dropdown' | 'custom' | 'label'; // 新增 'custom' 类型
  icon?: string;
  icon?: any;
  label?: string;
  tooltip?: string;
  disabled?: boolean;
  onClick?: () => void;
  menuItems?: ToolbarMenuItem[];
  // 新增：自定义组件渲染函数（当 type 为 'custom' 时生效）
  render?: () => JSX.Element; 
  customStyle?: Record<string, string | number>;
  customType?: 'primary-white' | ''; 
}

// 组件Props
const props = defineProps<{
  size?: 'default' | 'small'; // 尺寸
  bgColor?: string; // 背景色
  bordered?: boolean; // 是否显示边框
  leftItems?: ToolbarItemProps[]; // 左侧工具项
  rightItems?: ToolbarItemProps[]; // 右侧工具项
}>();

// 计算容器样式
const containerStyle = computed(() => ({
  backgroundColor: props.bgColor || '#f5f5f5',
  height: props.size === 'small' ? '36px' : '48px',
  borderBottom: props.bordered ? '1px solid #e0e0e0' : 'none',
}));

// 处理工具项点击
const handleItemClick = (item: ToolbarItemProps) => {
  if (!item.disabled && item.onClick) {
    // item.onClick();
    emit('click', item);
  }
};

// 处理下拉菜单点击
const handleMenuClick = (item: ToolbarItemProps, menuKey: string) => {
  if (item.disabled) return;
  // const menuItem = item.menuItems?.find(m => m.key === menuKey);
  // menuItem?.onClick();
  emit('menu-click', item, menuKey); // 正确传递两个参数
};

// 暴露事件
const emit = defineEmits<{
  /** 工具项点击时触发 */
  (e: 'click', item: ToolbarItemProps): void;
  /** 下拉菜单项点击时触发 */
  (e: 'menu-click', item: ToolbarItemProps, menuKey: string): void;
}>();




</script>

<style scoped>
/* 替换后的纯 CSS 样式 */
.toolbar-item {
  /* 原 font-size: 14px; 改为 */
  font-size: 1em !important; 
  padding: 0.285em 0.571em; /* 等价于 4px 8px（14px基准），自动缩放 */
}
.toolbar {
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 8px;
  user-select: none;
}

.toolbar .toolbar-group {
  display: flex;
  align-items: center;
  gap: 2px;
}

.toolbar .toolbar-group.left {
  margin-right: auto;
}

.toolbar .toolbar-group.right {
  margin-left: auto;
}
</style>